<template>
  <div>
    <div class="chart">
      <div class="lengends" style="width: 100%">
        <ul>
          <li v-for="(item, index) in $parent.$parent.result.industryDynamism.lineData.countries" :key="index">
            <div class="lengendtext">
              <span class="lengendanme">{{ item | lengthFormate }}</span>
              <span class="lengenddelete" @click="deleteLine1(index)"><i class="el-icon-close"></i></span>
            </div>
          </li>
        </ul>
      </div>
      <div style="clear: both"></div>
      <div class="charsTal">
        <div id="industryDynamismLine" style="width: 80%; height: 400px;"></div>
        <div id="industryDynamismPie" style="width: 35%; height: 400px"></div>
        <div class="box2LeftBottom"  v-if="$parent.$parent.result.industryDynamism.pieData.checkedCountry">
          National Industry dynamism Of
          {{this.$parent.$parent.result.industryDynamism.pieData.checkedCountry}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      lineChart: null,
      pieChart: null,
      pieChartData: []
    };
  },
  filters: {
    lengthFormate(value) {
      if (value && value !== '' && value.length > 30) {
        return value.substring(0, 30) + '...'
      }
      return value
    }
  },
  mounted() {
  },
  watch: {
    '$parent.$parent.result.industryDynamism.pieData.checkedCountry'(newVal) {
      for (let i = 0; i < this.$parent.$parent.result.industryDynamism.pieData.countries.length; i++) {
        if (this.$parent.$parent.result.industryDynamism.pieData.countries[i] === newVal) {
          const data = this.$parent.$parent.result.industryDynamism.pieData.pieData[i]
          this.pieChartData = []
          for (let dataKey in data) {
            this.pieChartData.push({name: dataKey, value: data[dataKey]})
          }
          this.drawPie()
          break
        }
      }
    }
  },
  methods: {
    deleteLine1(index) {
      var myChartNew = echarts.init(document.getElementById("industryDynamismLine"));
      this.$parent.$parent.result.industryDynamism.lineData.countries.splice(index, 1)
      var option = myChartNew.getOption();
      option.xAxis[0].data.splice(index, 1);
      option.series[0].data.splice(index, 1);
      myChartNew.clear();
      myChartNew.setOption(option);
    },
    drawLine() {
      if (this.lineChart != null) {
        this.lineChart.dispose()
      }
      this.lineChart = echarts.init(document.getElementById("industryDynamismLine"));
      this.lineChart.clear()
      window.onresize = this.lineChart.resize
      this.lineChart.setOption({
        title: {
          text: '',
          subtext: 'Articles'
        },
        tooltip: {trigger: "axis"},
        grid: {
          //距离左边的距离
          left: "4%",
          //距离右边的距离
//           right: "4%",
          //距离底部的距离
//           bottom: "3%",
//           containLabel: true
        },
        xAxis: {
          type: "category",
          axisLabel: {rotate: -20},
          data: this.$parent.$parent.result.industryDynamism.lineData.countries
        },
        yAxis: {type: "value"},
        series: [
          {
            data: this.$parent.$parent.result.industryDynamism.lineData.lineData,
            type: 'bar',
            itemStyle: {
              color: "#409eff",
            },
            emphasis: {
              itemStyle: {
                color: "#0872e8"
              }
            },
          }
        ]
      })
      const _this = this
      this.lineChart.on('click', function (params) {
        _this.$parent.$parent.result.industryDynamism.pieData.checkedCountry = params.data[0]
      })
    },
    drawPie() {
      if (this.pieChart != null) {
        this.pieChart.dispose()
      }
      this.pieChart = echarts.init(document.getElementById("industryDynamismPie"));
      this.pieChart.clear()
      window.onresize = this.pieChart.resize
      this.pieChart.setOption({
        color: ['#5470c6', '#92cc76', '#fac858', '#ee6767', '#73c0de', '#3ba272' ,'#fc8453' ,'#9a60b4'
          ,'#eb7bcc' ,'#5470c6'],
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          confine: true,//限制tooltip在图表范围内展示
          extraCssText: 'max-height:10%;overflow:scroll',//最大高度以及超出处理
          enterable: true//鼠标可以进入tooltip区域，使用滚动条
        },
        /*legend: {
          top: "1%",
          left: "center",
          formatter: function (name) {
            console.log(name)
            return echarts.format.truncateText(name, 100, '12px Microsoft Yahei', '…')
          },
        },*/
        series: {
          name: "",
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          itemStyle: {borderRadius: 10, borderColor: "#fff", borderWidth: 2},
          label: {show: false, position: "center"},
          emphasis: {label: {show: false, fontSize: "40", fontWeight: "bold"}},
          labelLine: {show: false},
          data: this.pieChartData
        }
      })
    }
  }
};
</script>

<style scoped>
.charsTal {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.lengends ul li {
  float: left;
  display: flex;
  cursor: pointer;
  align-items: center;
  padding: 0 30px 10px 0;
}

/*.lengends ul {
  margin-left: 15px;
}*/

.lengendtext {
  font-size: 12px;
  color: rgb(127, 127, 127);
  margin-top: 5px;
  padding: 1px 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
}

.lengendtext .lengenddelete {
  font-size: 14px;
}

.lengendtext .lengenddelete {
  margin-left: 10px;
}

.box2LeftBottom {
  padding: 0 10px;
  /*height: 35px;*/
  /*line-height: 35px;*/
  background: #409eff;
  color: #fff;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  position: absolute;
  right: 0;
  bottom: 30px;
}
</style>
